// import DownloadImage from "bam-node-evp/src/Utilities/DownloadImage";
import omit from 'lodash/omit'
import SaveFile from './SaveFile'

export default function SaveImage({ data, player, schema }, callback) {
    const options = {}
    options.appType = 'leaderboard-statcast-field'

    // eslint-disable-next-line no-param-reassign
    data = data.map((d) =>
        omit(d, [
            'des',
            'on_3b',
            'on_2b',
            'on_1b',
            'sv_id',
            'play_id',
            'h_launch_speedangle_code',
            'if_fielding_alignment',
            'of_fielding_alignment',
            'pos1_int_start_distance',
            'pos4_int_start_distance',
            'pos7_int_start_distance',
            'pos2_int_start_distance',
            'pos5_int_start_distance',
            'pos8_int_start_distance',
            'pos3_int_start_distance',
            'pos6_int_start_distance',
            'pos9_int_start_distance',
        ])
    )

    fetch(`/evp/add`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow', // manual, *follow, error
        body: JSON.stringify({
            player,
            data,
            schema,
            appType: 'evp',
        }),
    })
        .then((response) => {
            if (!response.ok) {
                return { error: 'No data' }
            }
            return response.json()
        })
        .then((response) => {
            if (response.error) {
                callback(response.err)
            }
            // callback(null, response.id);
            else if (!options.embed) {
                SaveFile(response.id, player, schema, options, () => {
                    callback(null, response.id)
                })
            } else {
                callback(null, { link: response.id })
            }
        })
}
